import React from "react"
import { useHistory } from "react-router-dom"
import { defineMessages } from "react-intl"

import Button from "@material-ui/core/Button"
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"

import { words } from "../../i18n/lstrings"
import img from "../../styles/img/500.png"
import useSmartFormat from "../../i18n/useSmartFormat"

const messages = defineMessages({
  title: {
    id: "error.500.subtitle",
    defaultMessage: "An unexpected internal error occurred"
  }
})

export default function ErrorPage() {
  const format = useSmartFormat()
  const history = useHistory()

  return (
    <Container className="page-not-found">
      <img src={img} alt="500 error" />
      <Typography variant="h2">{format(messages.title)}</Typography>
      <Button
        color="primary"
        onClick={() => {
          history.goBack()
        }}
      >
        <ChevronLeftIcon />
        <Typography>{format(words.return)}</Typography>
      </Button>
    </Container>
  )
}
